// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cVqT0","controls":"styles_controls__hepuU","charLimit":"styles_charLimit__3C84p","input":"styles_input__-vCVt","send":"styles_send__2HYpx"};